import { RegionsEnum } from "redlineLibsServerSafe"
import { RegionsData } from "./regions.types"

export const regionsData: RegionsData = {
  [RegionsEnum.NYCHDC]: {
    enabled: true,
    audioTour: false,
    firewall: false,
    titleRedlining: "",
    titleStories: "Stories from New York City",
    label: "NYC HDC",
    region: RegionsEnum.NYCHDC,
    redliningRegion: RegionsEnum.MANHATTAN_NY,
    location: { lng: -73.97, lat: 40.76 },
    geoJson: "NYManhattan1937.json",
    zoom: 11,
  },
  [RegionsEnum.EMERGENTWORKS]: {
    enabled: true,
    audioTour: false,
    firewall: false,
    titleRedlining: "",
    titleStories: "Stories from New York City",
    label: "Emergent Works",
    region: RegionsEnum.EMERGENTWORKS,
    redliningRegion: RegionsEnum.MANHATTAN_NY,
    location: { lng: -73.97, lat: 40.76 },
    geoJson: "NYManhattan1937.json",
    zoom: 11,
  },
  [RegionsEnum.NAR]: {
    enabled: true,
    audioTour: true,
    firewall: false,
    titleRedlining: "",
    titleStories: "Stories from Across Our Nation",
    label: "National Association of Realtors",
    region: RegionsEnum.NAR,
    redliningRegion: RegionsEnum.DALLAS_TX,
    location: { lng: -96.91, lat: 38.30 },
    geoJson: "MDBaltimore1937.json",
    zoom: 5,
  },
  [RegionsEnum.BALTIMORE_MD]: {
    enabled: true,
    audioTour: false,
    firewall: false,
    titleRedlining: "Redlining in Baltimore",
    titleStories: "Stories from Baltimore",
    label: "Baltimore",
    region: RegionsEnum.BALTIMORE_MD,
    redliningRegion: RegionsEnum.BALTIMORE_MD,
    location: { lng: -76.61, lat: 39.27 },
    geoJson: "MDBaltimore1937.json",
    zoom: 12,
  },
  [RegionsEnum.CLEVELAND_OH]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Cleveland",
    region: RegionsEnum.CLEVELAND_OH,
    redliningRegion: RegionsEnum.CLEVELAND_OH,
    location: { lng: -81.70, lat: 41.44 },
    geoJson: "OHCleveland1939.json",
    zoom: 11,
  },
  [RegionsEnum.DETROIT_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Detroit",
    region: RegionsEnum.DETROIT_MI,
    redliningRegion: RegionsEnum.DETROIT_MI,
    location: { lng: -83.09, lat: 42.36 },
    geoJson: "MIDetroit1939.json",
    zoom: 11,
  },
  [RegionsEnum.BIRMINGHAM_AL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Birmingham",
    region: RegionsEnum.BIRMINGHAM_AL,
    redliningRegion: RegionsEnum.BIRMINGHAM_AL,
    location: { lng: 0, lat: 0 },
    geoJson: "ALBirmingham1937.json",
  },
  [RegionsEnum.MOBILE_AL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Mobile",
    region: RegionsEnum.MOBILE_AL,
    redliningRegion: RegionsEnum.MOBILE_AL,
    location: { lng: 0, lat: 0 },
    geoJson: "ALMobile1937.json",
  },
  [RegionsEnum.MONTGOMERY_AL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Montgomery",
    region: RegionsEnum.MONTGOMERY_AL,
    redliningRegion: RegionsEnum.MONTGOMERY_AL,
    location: { lng: 0, lat: 0 },
    geoJson: "ALMontgomery1937.json",
  },
  [RegionsEnum.LITTLEROCK_AR]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Littlerock",
    region: RegionsEnum.LITTLEROCK_AR,
    redliningRegion: RegionsEnum.LITTLEROCK_AR,
    location: { lng: 0, lat: 0 },
    geoJson: "ARLittleRock19XX.json",
  },
  [RegionsEnum.PHOENIX_AZ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Phoenix",
    region: RegionsEnum.PHOENIX_AZ,
    redliningRegion: RegionsEnum.PHOENIX_AZ,
    location: { lng: 0, lat: 0 },
    geoJson: "AZPhoenix19XX.json",
  },
  [RegionsEnum.FRESNO_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Fresno",
    region: RegionsEnum.FRESNO_CA,
    redliningRegion: RegionsEnum.FRESNO_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CAFresno1936.json",
  },
  [RegionsEnum.LOSANGELES_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Losangeles",
    region: RegionsEnum.LOSANGELES_CA,
    redliningRegion: RegionsEnum.LOSANGELES_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CALosAngeles1939.json",
  },
  [RegionsEnum.OAKLAND_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Oakland",
    region: RegionsEnum.OAKLAND_CA,
    redliningRegion: RegionsEnum.OAKLAND_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CAOakland1937.json",
  },
  [RegionsEnum.SACRAMENTO_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Sacramento",
    region: RegionsEnum.SACRAMENTO_CA,
    redliningRegion: RegionsEnum.SACRAMENTO_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CASacramento1937.json",
  },
  [RegionsEnum.SANDIEGO_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Sandiego",
    region: RegionsEnum.SANDIEGO_CA,
    redliningRegion: RegionsEnum.SANDIEGO_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CASanDiego1938.json",
  },
  [RegionsEnum.SANFRANCISCO_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Sanfrancisco",
    region: RegionsEnum.SANFRANCISCO_CA,
    redliningRegion: RegionsEnum.SANFRANCISCO_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CASanFrancisco1937.json",
  },
  [RegionsEnum.SANJOSE_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Sanjose",
    region: RegionsEnum.SANJOSE_CA,
    redliningRegion: RegionsEnum.SANJOSE_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CASanJose1937.json",
  },
  [RegionsEnum.STOCKTON_CA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Stockton",
    region: RegionsEnum.STOCKTON_CA,
    redliningRegion: RegionsEnum.STOCKTON_CA,
    location: { lng: 0, lat: 0 },
    geoJson: "CAStockton1938.json",
  },
  [RegionsEnum.DENVER_CO]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Denver",
    region: RegionsEnum.DENVER_CO,
    redliningRegion: RegionsEnum.DENVER_CO,
    location: { lng: 0, lat: 0 },
    geoJson: "CODenver1938.json",
  },
  [RegionsEnum.PUEBLO_CO]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Pueblo",
    region: RegionsEnum.PUEBLO_CO,
    redliningRegion: RegionsEnum.PUEBLO_CO,
    location: { lng: 0, lat: 0 },
    geoJson: "COPueblo19XX.json",
  },
  [RegionsEnum.BRIDGEPORTANDFAIRFIELD_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Bridgeportandfairfield",
    region: RegionsEnum.BRIDGEPORTANDFAIRFIELD_CT,
    redliningRegion: RegionsEnum.BRIDGEPORTANDFAIRFIELD_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTBridgeportandFairfield1937.json",
  },
  [RegionsEnum.HARTFORD_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Hartford",
    region: RegionsEnum.HARTFORD_CT,
    redliningRegion: RegionsEnum.HARTFORD_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTHartford19XX.json",
  },
  [RegionsEnum.NEWBRITAIN_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Newbritain",
    region: RegionsEnum.NEWBRITAIN_CT,
    redliningRegion: RegionsEnum.NEWBRITAIN_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTNewBritain1937.json",
  },
  [RegionsEnum.NEWHAVEN_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Newhaven",
    region: RegionsEnum.NEWHAVEN_CT,
    redliningRegion: RegionsEnum.NEWHAVEN_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTNewHaven1937.json",
  },
  [RegionsEnum.STAMFORDDARIENANDNEWCANAAN_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Stamforddarienandnewcanaan",
    region: RegionsEnum.STAMFORDDARIENANDNEWCANAAN_CT,
    redliningRegion: RegionsEnum.STAMFORDDARIENANDNEWCANAAN_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTStamfordDarienandNewCanaan1937.json",
  },
  [RegionsEnum.WATERBURY_CT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Waterbury",
    region: RegionsEnum.WATERBURY_CT,
    redliningRegion: RegionsEnum.WATERBURY_CT,
    location: { lng: 0, lat: 0 },
    geoJson: "CTWaterbury19XX.json",
  },
  [RegionsEnum.JACKSONVILLE_FL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Jacksonville",
    region: RegionsEnum.JACKSONVILLE_FL,
    redliningRegion: RegionsEnum.JACKSONVILLE_FL,
    location: { lng: 0, lat: 0 },
    geoJson: "FLJacksonville1937.json",
  },
  [RegionsEnum.MIAMI_FL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Miami",
    region: RegionsEnum.MIAMI_FL,
    redliningRegion: RegionsEnum.MIAMI_FL,
    location: { lng: 0, lat: 0 },
    geoJson: "FLMiami1937.json",
  },
  [RegionsEnum.STPETERSBURG_FL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Stpetersburg",
    region: RegionsEnum.STPETERSBURG_FL,
    redliningRegion: RegionsEnum.STPETERSBURG_FL,
    location: { lng: 0, lat: 0 },
    geoJson: "FLStPetersburg1937.json",
  },
  [RegionsEnum.TAMPA_FL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Tampa",
    region: RegionsEnum.TAMPA_FL,
    redliningRegion: RegionsEnum.TAMPA_FL,
    location: { lng: 0, lat: 0 },
    geoJson: "FLTampa1936.json",
  },
  [RegionsEnum.ATLANTA_GA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Atlanta",
    region: RegionsEnum.ATLANTA_GA,
    redliningRegion: RegionsEnum.ATLANTA_GA,
    location: { lng: 0, lat: 0 },
    geoJson: "GAAtlanta1938.json",
  },
  [RegionsEnum.AUGUSTA_GA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Augusta",
    region: RegionsEnum.AUGUSTA_GA,
    redliningRegion: RegionsEnum.AUGUSTA_GA,
    location: { lng: 0, lat: 0 },
    geoJson: "GAAugusta1937.json",
  },
  [RegionsEnum.COLUMBUS_GA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Columbus",
    region: RegionsEnum.COLUMBUS_GA,
    redliningRegion: RegionsEnum.COLUMBUS_GA,
    location: { lng: 0, lat: 0 },
    geoJson: "GAColumbus1937.json",
  },
  [RegionsEnum.MACON_GA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Macon",
    region: RegionsEnum.MACON_GA,
    redliningRegion: RegionsEnum.MACON_GA,
    location: { lng: 0, lat: 0 },
    geoJson: "GAMacon1937.json",
  },
  [RegionsEnum.SAVANNAH_GA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Savannah",
    region: RegionsEnum.SAVANNAH_GA,
    redliningRegion: RegionsEnum.SAVANNAH_GA,
    location: { lng: 0, lat: 0 },
    geoJson: "GASavannah19XX.json",
  },
  [RegionsEnum.CEDARRAPIDS_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Cedarrapids",
    region: RegionsEnum.CEDARRAPIDS_IA,
    redliningRegion: RegionsEnum.CEDARRAPIDS_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IACedarRapids19XX.json",
  },
  [RegionsEnum.DAVENPORT_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Davenport",
    region: RegionsEnum.DAVENPORT_IA,
    redliningRegion: RegionsEnum.DAVENPORT_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IADavenport19XX.json",
  },
  [RegionsEnum.DESMOINES_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Desmoines",
    region: RegionsEnum.DESMOINES_IA,
    redliningRegion: RegionsEnum.DESMOINES_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IADesMoines19XX.json",
  },
  [RegionsEnum.DUBUQUE_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Dubuque",
    region: RegionsEnum.DUBUQUE_IA,
    redliningRegion: RegionsEnum.DUBUQUE_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IADubuque19XX.json",
  },
  [RegionsEnum.SIOUXCITY_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Siouxcity",
    region: RegionsEnum.SIOUXCITY_IA,
    redliningRegion: RegionsEnum.SIOUXCITY_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IASiouxCity19XX.json",
  },
  [RegionsEnum.WATERLOO_IA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Waterloo",
    region: RegionsEnum.WATERLOO_IA,
    redliningRegion: RegionsEnum.WATERLOO_IA,
    location: { lng: 0, lat: 0 },
    geoJson: "IAWaterloo19XX.json",
  },
  [RegionsEnum.AURORA_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Aurora",
    region: RegionsEnum.AURORA_IL,
    redliningRegion: RegionsEnum.AURORA_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILAurora1938.json",
  },
  [RegionsEnum.CHICAGO_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Chicago",
    region: RegionsEnum.CHICAGO_IL,
    redliningRegion: RegionsEnum.CHICAGO_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILChicago1940.json",
  },
  [RegionsEnum.DECATUR_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Decatur",
    region: RegionsEnum.DECATUR_IL,
    redliningRegion: RegionsEnum.DECATUR_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILDecatur1937.json",
  },
  [RegionsEnum.EASTSTLOUIS_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Eaststlouis",
    region: RegionsEnum.EASTSTLOUIS_IL,
    redliningRegion: RegionsEnum.EASTSTLOUIS_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILEastStLouis1940.json",
  },
  [RegionsEnum.JOLIET_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Joliet",
    region: RegionsEnum.JOLIET_IL,
    redliningRegion: RegionsEnum.JOLIET_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILJoliet1937.json",
  },
  [RegionsEnum.ROCKFORD_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Rockford",
    region: RegionsEnum.ROCKFORD_IL,
    redliningRegion: RegionsEnum.ROCKFORD_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILRockford1937.json",
  },
  [RegionsEnum.SPRINGFIELD_IL]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Springfield",
    region: RegionsEnum.SPRINGFIELD_IL,
    redliningRegion: RegionsEnum.SPRINGFIELD_IL,
    location: { lng: 0, lat: 0 },
    geoJson: "ILSpringfield1937.json",
  },
  [RegionsEnum.EVANSVILLE_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Evansville",
    region: RegionsEnum.EVANSVILLE_IN,
    redliningRegion: RegionsEnum.EVANSVILLE_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INEvansville1937.json",
  },
  [RegionsEnum.FORTWAYNE_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Fortwayne",
    region: RegionsEnum.FORTWAYNE_IN,
    redliningRegion: RegionsEnum.FORTWAYNE_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INFortWayne1937.json",
  },
  [RegionsEnum.INDIANAPOLIS_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Indianapolis",
    region: RegionsEnum.INDIANAPOLIS_IN,
    redliningRegion: RegionsEnum.INDIANAPOLIS_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INIndianapolis1937.json",
  },
  [RegionsEnum.LAKECOGARY_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lakecogary",
    region: RegionsEnum.LAKECOGARY_IN,
    redliningRegion: RegionsEnum.LAKECOGARY_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INLakeCoGary1937.json",
  },
  [RegionsEnum.MUNCIE_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Muncie",
    region: RegionsEnum.MUNCIE_IN,
    redliningRegion: RegionsEnum.MUNCIE_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INMuncie1937.json",
  },
  [RegionsEnum.SOUTHBEND_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Southbend",
    region: RegionsEnum.SOUTHBEND_IN,
    redliningRegion: RegionsEnum.SOUTHBEND_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INSouthBend1937.json",
  },
  [RegionsEnum.TERREHAUTE_IN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Terrehaute",
    region: RegionsEnum.TERREHAUTE_IN,
    redliningRegion: RegionsEnum.TERREHAUTE_IN,
    location: { lng: 0, lat: 0 },
    geoJson: "INTerreHaute1937.json",
  },
  [RegionsEnum.TOPEKA_KS]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Topeka",
    region: RegionsEnum.TOPEKA_KS,
    redliningRegion: RegionsEnum.TOPEKA_KS,
    location: { lng: 0, lat: 0 },
    geoJson: "KSTopeka19XX.json",
  },
  [RegionsEnum.WICHITA_KS]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Wichita",
    region: RegionsEnum.WICHITA_KS,
    redliningRegion: RegionsEnum.WICHITA_KS,
    location: { lng: 0, lat: 0 },
    geoJson: "KSWichita1937.json",
  },
  [RegionsEnum.NEWORLEANS_LA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Neworleans",
    region: RegionsEnum.NEWORLEANS_LA,
    redliningRegion: RegionsEnum.NEWORLEANS_LA,
    location: { lng: 0, lat: 0 },
    geoJson: "LANewOrleans1939.json",
  },
  [RegionsEnum.SHREVEPORT_LA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Shreveport",
    region: RegionsEnum.SHREVEPORT_LA,
    redliningRegion: RegionsEnum.SHREVEPORT_LA,
    location: { lng: 0, lat: 0 },
    geoJson: "LAShreveport19XX.json",
  },
  [RegionsEnum.ARLINGTON_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Arlington",
    region: RegionsEnum.ARLINGTON_MA,
    redliningRegion: RegionsEnum.ARLINGTON_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAArlington1939.json",
  },
  [RegionsEnum.BELMONT_MA]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Belmont",
    region: RegionsEnum.BELMONT_MA,
    redliningRegion: RegionsEnum.BELMONT_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MABelmont1939.json",
  },
  [RegionsEnum.BOSTON_MA]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Boston",
    region: RegionsEnum.BOSTON_MA,
    redliningRegion: RegionsEnum.BOSTON_MA,
    location: { lng: -71.09, lat: 42.30 },
    geoJson: "MABoston1938.json",
  },
  [RegionsEnum.BRAINTREE_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Braintree",
    region: RegionsEnum.BRAINTREE_MA,
    redliningRegion: RegionsEnum.BRAINTREE_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MABraintree1939.json",
  },
  [RegionsEnum.BROCKTON_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Brockton",
    region: RegionsEnum.BROCKTON_MA,
    redliningRegion: RegionsEnum.BROCKTON_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MABrockton1937.json",
  },
  [RegionsEnum.BROOKLINE_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Brookline",
    region: RegionsEnum.BROOKLINE_MA,
    redliningRegion: RegionsEnum.BROOKLINE_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MABrookline1939.json",
  },
  [RegionsEnum.CAMBRIDGE_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Cambridge",
    region: RegionsEnum.CAMBRIDGE_MA,
    redliningRegion: RegionsEnum.CAMBRIDGE_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MACambridge1939.json",
  },
  [RegionsEnum.CHELSEA_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Chelsea",
    region: RegionsEnum.CHELSEA_MA,
    redliningRegion: RegionsEnum.CHELSEA_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAChelsea1939.json",
  },
  [RegionsEnum.EVERETT_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Everett",
    region: RegionsEnum.EVERETT_MA,
    redliningRegion: RegionsEnum.EVERETT_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAEverett19XX.json",
  },
  [RegionsEnum.FITCHBURG_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Fitchburg",
    region: RegionsEnum.FITCHBURG_MA,
    redliningRegion: RegionsEnum.FITCHBURG_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAFitchburg1936.json",
  },
  [RegionsEnum.HAVERHILL_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Haverhill",
    region: RegionsEnum.HAVERHILL_MA,
    redliningRegion: RegionsEnum.HAVERHILL_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAHaverhill1937.json",
  },
  [RegionsEnum.HOLYOKECHICOPEE_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Holyokechicopee",
    region: RegionsEnum.HOLYOKECHICOPEE_MA,
    redliningRegion: RegionsEnum.HOLYOKECHICOPEE_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAHolyokeChicopee1937.json",
  },
  [RegionsEnum.LAWRENCE_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lawrence",
    region: RegionsEnum.LAWRENCE_MA,
    redliningRegion: RegionsEnum.LAWRENCE_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MALawrence1937.json",
  },
  [RegionsEnum.LEXINGTON_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lexington",
    region: RegionsEnum.LEXINGTON_MA,
    redliningRegion: RegionsEnum.LEXINGTON_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MALexington19XX.json",
  },
  [RegionsEnum.LOWELL_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lowell",
    region: RegionsEnum.LOWELL_MA,
    redliningRegion: RegionsEnum.LOWELL_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MALowell1936.json",
  },
  [RegionsEnum.LYNN_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lynn",
    region: RegionsEnum.LYNN_MA,
    redliningRegion: RegionsEnum.LYNN_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MALynn1936.json",
  },
  [RegionsEnum.MALDEN_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Malden",
    region: RegionsEnum.MALDEN_MA,
    redliningRegion: RegionsEnum.MALDEN_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAMalden19XX.json",
  },
  [RegionsEnum.MILTON_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Milton",
    region: RegionsEnum.MILTON_MA,
    redliningRegion: RegionsEnum.MILTON_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAMilton1939.json",
  },
  [RegionsEnum.PITTSFIELD_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Pittsfield",
    region: RegionsEnum.PITTSFIELD_MA,
    redliningRegion: RegionsEnum.PITTSFIELD_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAPittsfield1936.json",
  },
  [RegionsEnum.QUINCY_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Quincy",
    region: RegionsEnum.QUINCY_MA,
    redliningRegion: RegionsEnum.QUINCY_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAQuincy1939.json",
  },
  [RegionsEnum.SALEM_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Salem",
    region: RegionsEnum.SALEM_MA,
    redliningRegion: RegionsEnum.SALEM_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MASalem1936.json",
  },
  [RegionsEnum.WORCESTER_MA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Worcester",
    region: RegionsEnum.WORCESTER_MA,
    redliningRegion: RegionsEnum.WORCESTER_MA,
    location: { lng: 0, lat: 0 },
    geoJson: "MAWorcester1936.json",
  },
  [RegionsEnum.BATTLECREEK_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Battlecreek",
    region: RegionsEnum.BATTLECREEK_MI,
    redliningRegion: RegionsEnum.BATTLECREEK_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIBattleCreek1937.json",
  },
  [RegionsEnum.BAYCITY_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Baycity",
    region: RegionsEnum.BAYCITY_MI,
    redliningRegion: RegionsEnum.BAYCITY_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIBayCity1937.json",
  },
  [RegionsEnum.FLINT_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Flint",
    region: RegionsEnum.FLINT_MI,
    redliningRegion: RegionsEnum.FLINT_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIFlint1937.json",
  },
  [RegionsEnum.GRANDRAPIDS_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Grandrapids",
    region: RegionsEnum.GRANDRAPIDS_MI,
    redliningRegion: RegionsEnum.GRANDRAPIDS_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIGrandRapids1937.json",
  },
  [RegionsEnum.KALAMAZOO_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Kalamazoo",
    region: RegionsEnum.KALAMAZOO_MI,
    redliningRegion: RegionsEnum.KALAMAZOO_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIKalamazoo1937.json",
  },
  [RegionsEnum.MUSKEGON_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Muskegon",
    region: RegionsEnum.MUSKEGON_MI,
    redliningRegion: RegionsEnum.MUSKEGON_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIMuskegon1937.json",
  },
  [RegionsEnum.PONTIAC_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Pontiac",
    region: RegionsEnum.PONTIAC_MI,
    redliningRegion: RegionsEnum.PONTIAC_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MIPontiac1937.json",
  },
  [RegionsEnum.SAGINAW_MI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Saginaw",
    region: RegionsEnum.SAGINAW_MI,
    redliningRegion: RegionsEnum.SAGINAW_MI,
    location: { lng: 0, lat: 0 },
    geoJson: "MISaginaw1937.json",
  },
  [RegionsEnum.DULUTH_MN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Duluth",
    region: RegionsEnum.DULUTH_MN,
    redliningRegion: RegionsEnum.DULUTH_MN,
    location: { lng: 0, lat: 0 },
    geoJson: "MNDuluth1936.json",
  },
  [RegionsEnum.MINNEAPOLIS_MN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Minneapolis",
    region: RegionsEnum.MINNEAPOLIS_MN,
    redliningRegion: RegionsEnum.MINNEAPOLIS_MN,
    location: { lng: 0, lat: 0 },
    geoJson: "MNMinneapolis1937.json",
  },
  [RegionsEnum.STPAUL_MN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Stpaul",
    region: RegionsEnum.STPAUL_MN,
    redliningRegion: RegionsEnum.STPAUL_MN,
    location: { lng: 0, lat: 0 },
    geoJson: "MNStPaul19XX.json",
  },
  [RegionsEnum.GREATERKANSASCITY_MO]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Greaterkansascity",
    region: RegionsEnum.GREATERKANSASCITY_MO,
    redliningRegion: RegionsEnum.GREATERKANSASCITY_MO,
    location: { lng: 0, lat: 0 },
    geoJson: "MOGreaterKansasCity1939.json",
  },
  [RegionsEnum.SPRINGFIELD_MO]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Springfield",
    region: RegionsEnum.SPRINGFIELD_MO,
    redliningRegion: RegionsEnum.SPRINGFIELD_MO,
    location: { lng: 0, lat: 0 },
    geoJson: "MOSpringfield1937.json",
  },
  [RegionsEnum.STJOSEPH_MO]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Stjoseph",
    region: RegionsEnum.STJOSEPH_MO,
    redliningRegion: RegionsEnum.STJOSEPH_MO,
    location: { lng: 0, lat: 0 },
    geoJson: "MOStJoseph1937.json",
  },
  [RegionsEnum.ASHEVILLE_NC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Asheville",
    region: RegionsEnum.ASHEVILLE_NC,
    redliningRegion: RegionsEnum.ASHEVILLE_NC,
    location: { lng: 0, lat: 0 },
    geoJson: "NCAsheville1937.json",
  },
  [RegionsEnum.CHARLOTTE_NC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Charlotte",
    region: RegionsEnum.CHARLOTTE_NC,
    redliningRegion: RegionsEnum.CHARLOTTE_NC,
    location: { lng: 0, lat: 0 },
    geoJson: "NCCharlotte1935.json",
  },
  [RegionsEnum.DURHAM_NC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Durham",
    region: RegionsEnum.DURHAM_NC,
    redliningRegion: RegionsEnum.DURHAM_NC,
    location: { lng: 0, lat: 0 },
    geoJson: "NCDurham1937.json",
  },
  [RegionsEnum.GREENSBORO_NC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Greensboro",
    region: RegionsEnum.GREENSBORO_NC,
    redliningRegion: RegionsEnum.GREENSBORO_NC,
    location: { lng: 0, lat: 0 },
    geoJson: "NCGreensboro1936.json",
  },
  [RegionsEnum.WINSTONSALEM_NC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Winstonsalem",
    region: RegionsEnum.WINSTONSALEM_NC,
    redliningRegion: RegionsEnum.WINSTONSALEM_NC,
    location: { lng: 0, lat: 0 },
    geoJson: "NCWinstonSalem1937.json",
  },
  [RegionsEnum.MANCHESTER_NH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Manchester",
    region: RegionsEnum.MANCHESTER_NH,
    redliningRegion: RegionsEnum.MANCHESTER_NH,
    location: { lng: 0, lat: 0 },
    geoJson: "NHManchester1937.json",
  },
  [RegionsEnum.ATLANTICCITY_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Atlanticcity",
    region: RegionsEnum.ATLANTICCITY_NJ,
    redliningRegion: RegionsEnum.ATLANTICCITY_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJAtlanticCity1940.json",
  },
  [RegionsEnum.BERGENCO_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Bergenco",
    region: RegionsEnum.BERGENCO_NJ,
    redliningRegion: RegionsEnum.BERGENCO_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJBergenCo1939.json",
  },
  [RegionsEnum.CAMDEN_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Camden",
    region: RegionsEnum.CAMDEN_NJ,
    redliningRegion: RegionsEnum.CAMDEN_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJCamden1937.json",
  },
  [RegionsEnum.ESSEXCO_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Essexco",
    region: RegionsEnum.ESSEXCO_NJ,
    redliningRegion: RegionsEnum.ESSEXCO_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJEssexCo1939.json",
  },
  [RegionsEnum.HUDSONCO_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Hudsonco",
    region: RegionsEnum.HUDSONCO_NJ,
    redliningRegion: RegionsEnum.HUDSONCO_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJHudsonCo1939.json",
  },
  [RegionsEnum.PASSAICCOUNTY_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Passaiccounty",
    region: RegionsEnum.PASSAICCOUNTY_NJ,
    redliningRegion: RegionsEnum.PASSAICCOUNTY_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJPassaicCounty1939.json",
  },
  [RegionsEnum.PERTHAMBOY_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Perthamboy",
    region: RegionsEnum.PERTHAMBOY_NJ,
    redliningRegion: RegionsEnum.PERTHAMBOY_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJPerthAmboy1937.json",
  },
  [RegionsEnum.TRENTON_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Trenton",
    region: RegionsEnum.TRENTON_NJ,
    redliningRegion: RegionsEnum.TRENTON_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJTrenton1937.json",
  },
  [RegionsEnum.UNIONCO_NJ]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Unionco",
    region: RegionsEnum.UNIONCO_NJ,
    redliningRegion: RegionsEnum.UNIONCO_NJ,
    location: { lng: 0, lat: 0 },
    geoJson: "NJUnionCo1939.json",
  },
  [RegionsEnum.ALBANY_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Albany",
    region: RegionsEnum.ALBANY_NY,
    redliningRegion: RegionsEnum.ALBANY_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYAlbany1938.json",
  },
  [RegionsEnum.BINGHAMTONJOHNSONCITY_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Binghamtonjohnsoncity",
    region: RegionsEnum.BINGHAMTONJOHNSONCITY_NY,
    redliningRegion: RegionsEnum.BINGHAMTONJOHNSONCITY_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYBinghamtonJohnsonCity1937.json",
  },
  [RegionsEnum.BRONX_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Bronx",
    region: RegionsEnum.BRONX_NY,
    redliningRegion: RegionsEnum.BRONX_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYBronx1938.json",
  },
  [RegionsEnum.BROOKLYN_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Brooklyn",
    region: RegionsEnum.BROOKLYN_NY,
    redliningRegion: RegionsEnum.BROOKLYN_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYBrooklyn1938.json",
  },
  [RegionsEnum.BUFFALO_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Buffalo",
    region: RegionsEnum.BUFFALO_NY,
    redliningRegion: RegionsEnum.BUFFALO_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYBuffalo1937.json",
  },
  [RegionsEnum.ELMIRA_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Elmira",
    region: RegionsEnum.ELMIRA_NY,
    redliningRegion: RegionsEnum.ELMIRA_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYElmira1937.json",
  },
  [RegionsEnum.JAMESTOWN_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Jamestown",
    region: RegionsEnum.JAMESTOWN_NY,
    redliningRegion: RegionsEnum.JAMESTOWN_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYJamestown1937.json",
  },
  [RegionsEnum.LOWERWESTCHESTERCO_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Lowerwestchesterco",
    region: RegionsEnum.LOWERWESTCHESTERCO_NY,
    redliningRegion: RegionsEnum.LOWERWESTCHESTERCO_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYLowerWestchesterCo1940.json",
  },
  [RegionsEnum.MANHATTAN_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "Redlining in New York City",
    zoom: 11,
    titleStories: "",
    label: "Manhattan",
    region: RegionsEnum.MANHATTAN_NY,
    redliningRegion: RegionsEnum.MANHATTAN_NY,
    location: { lng: -73.97, lat: 40.76 },
    geoJson: "NYManhattan1937.json",
  },
  [RegionsEnum.NIAGARAFALLS_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Niagarafalls",
    region: RegionsEnum.NIAGARAFALLS_NY,
    redliningRegion: RegionsEnum.NIAGARAFALLS_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYNiagaraFalls1937.json",
  },
  [RegionsEnum.POUGHKEEPSIE_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Poughkeepsie",
    region: RegionsEnum.POUGHKEEPSIE_NY,
    redliningRegion: RegionsEnum.POUGHKEEPSIE_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYPoughkeepsie1938.json",
  },
  [RegionsEnum.QUEENS_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Queens",
    region: RegionsEnum.QUEENS_NY,
    redliningRegion: RegionsEnum.QUEENS_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYQueens1938.json",
  },
  [RegionsEnum.ROCHESTER_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Rochester",
    region: RegionsEnum.ROCHESTER_NY,
    redliningRegion: RegionsEnum.ROCHESTER_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYRochester1935.json",
  },
  [RegionsEnum.SCHENECTADY_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Schenectady",
    region: RegionsEnum.SCHENECTADY_NY,
    redliningRegion: RegionsEnum.SCHENECTADY_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYSchenectady1938.json",
  },
  [RegionsEnum.STATENISLAND_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Statenisland",
    region: RegionsEnum.STATENISLAND_NY,
    redliningRegion: RegionsEnum.STATENISLAND_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYStatenIsland1940.json",
  },
  [RegionsEnum.SYRACUSE_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Syracuse",
    region: RegionsEnum.SYRACUSE_NY,
    redliningRegion: RegionsEnum.SYRACUSE_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYSyracuse1937.json",
  },
  [RegionsEnum.TROY_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Troy",
    region: RegionsEnum.TROY_NY,
    redliningRegion: RegionsEnum.TROY_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYTroy1937.json",
  },
  [RegionsEnum.UTICA_NY]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    zoom: 12,
    titleStories: "",
    label: "Utica",
    region: RegionsEnum.UTICA_NY,
    redliningRegion: RegionsEnum.UTICA_NY,
    location: { lng: 0, lat: 0 },
    geoJson: "NYUtica1936.json",
  },
  [RegionsEnum.AKRON_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Akron",
    region: RegionsEnum.AKRON_OH,
    redliningRegion: RegionsEnum.AKRON_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHAkron1939.json",
  },
  [RegionsEnum.CANTON_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Canton",
    region: RegionsEnum.CANTON_OH,
    redliningRegion: RegionsEnum.CANTON_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHCanton1937.json",
  },
  [RegionsEnum.DAYTON_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Dayton",
    region: RegionsEnum.DAYTON_OH,
    redliningRegion: RegionsEnum.DAYTON_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHDayton1937.json",
  },
  [RegionsEnum.HAMILTON_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Hamilton",
    region: RegionsEnum.HAMILTON_OH,
    redliningRegion: RegionsEnum.HAMILTON_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHHamilton1938.json",
  },
  [RegionsEnum.LIMA_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lima",
    region: RegionsEnum.LIMA_OH,
    redliningRegion: RegionsEnum.LIMA_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHLima1937.json",
  },
  [RegionsEnum.LORAIN_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lorain",
    region: RegionsEnum.LORAIN_OH,
    redliningRegion: RegionsEnum.LORAIN_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHLorain1937.json",
  },
  [RegionsEnum.PORTSMOUTH_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Portsmouth",
    region: RegionsEnum.PORTSMOUTH_OH,
    redliningRegion: RegionsEnum.PORTSMOUTH_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHPortsmouth1938.json",
  },
  [RegionsEnum.SPRINGFIELD_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Springfield",
    region: RegionsEnum.SPRINGFIELD_OH,
    redliningRegion: RegionsEnum.SPRINGFIELD_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHSpringfield1938.json",
  },
  [RegionsEnum.TOLEDO_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Toledo",
    region: RegionsEnum.TOLEDO_OH,
    redliningRegion: RegionsEnum.TOLEDO_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHToledo1938.json",
  },
  [RegionsEnum.WARREN_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Warren",
    region: RegionsEnum.WARREN_OH,
    redliningRegion: RegionsEnum.WARREN_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHWarren1937.json",
  },
  [RegionsEnum.YOUNGSTOWN_OH]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Youngstown",
    region: RegionsEnum.YOUNGSTOWN_OH,
    redliningRegion: RegionsEnum.YOUNGSTOWN_OH,
    location: { lng: 0, lat: 0 },
    geoJson: "OHYoungstown1938.json",
  },
  [RegionsEnum.PORTLAND_OR]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Portland",
    region: RegionsEnum.PORTLAND_OR,
    redliningRegion: RegionsEnum.PORTLAND_OR,
    location: { lng: 0, lat: 0 },
    geoJson: "ORPortland1937.json",
  },
  [RegionsEnum.ALTOONA_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Altoona",
    region: RegionsEnum.ALTOONA_PA,
    redliningRegion: RegionsEnum.ALTOONA_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAAltoona1937.json",
  },
  [RegionsEnum.ERIE_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Erie",
    region: RegionsEnum.ERIE_PA,
    redliningRegion: RegionsEnum.ERIE_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAErie1937.json",
  },
  [RegionsEnum.JOHNSTOWN_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Johnstown",
    region: RegionsEnum.JOHNSTOWN_PA,
    redliningRegion: RegionsEnum.JOHNSTOWN_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAJohnstown1937.json",
  },
  [RegionsEnum.MCKEESPORT_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Mckeesport",
    region: RegionsEnum.MCKEESPORT_PA,
    redliningRegion: RegionsEnum.MCKEESPORT_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAMcKeesport1937.json",
  },
  [RegionsEnum.NEWCASTLE_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Newcastle",
    region: RegionsEnum.NEWCASTLE_PA,
    redliningRegion: RegionsEnum.NEWCASTLE_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PANewCastle1937.json",
  },
  [RegionsEnum.PHILADELPHIA_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Philadelphia",
    region: RegionsEnum.PHILADELPHIA_PA,
    redliningRegion: RegionsEnum.PHILADELPHIA_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAPhiladelphia1937.json",
  },
  [RegionsEnum.PITTSBURGH_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Pittsburgh",
    region: RegionsEnum.PITTSBURGH_PA,
    redliningRegion: RegionsEnum.PITTSBURGH_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAPittsburgh1937.json",
  },
  [RegionsEnum.YORK_PA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "York",
    region: RegionsEnum.YORK_PA,
    redliningRegion: RegionsEnum.YORK_PA,
    location: { lng: 0, lat: 0 },
    geoJson: "PAYork19XX.json",
  },
  [RegionsEnum.WOONSOCKET_RI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Woonsocket",
    region: RegionsEnum.WOONSOCKET_RI,
    redliningRegion: RegionsEnum.WOONSOCKET_RI,
    location: { lng: 0, lat: 0 },
    geoJson: "RIWoonsocket19XX.json",
  },
  [RegionsEnum.COLUMBIA_SC]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Columbia",
    region: RegionsEnum.COLUMBIA_SC,
    redliningRegion: RegionsEnum.COLUMBIA_SC,
    location: { lng: 0, lat: 0 },
    geoJson: "SCColumbia19XX.json",
  },
  [RegionsEnum.CHATTANOOGA_TN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Chattanooga",
    region: RegionsEnum.CHATTANOOGA_TN,
    redliningRegion: RegionsEnum.CHATTANOOGA_TN,
    location: { lng: 0, lat: 0 },
    geoJson: "TNChattanooga1939.json",
  },
  [RegionsEnum.KNOXVILLE_TN]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Knoxville",
    region: RegionsEnum.KNOXVILLE_TN,
    redliningRegion: RegionsEnum.KNOXVILLE_TN,
    location: { lng: 0, lat: 0 },
    geoJson: "TNKnoxville1939.json",
  },
  [RegionsEnum.DALLAS_TX]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "Redlining in Dallas & Houston",
    titleStories: "",
    label: "Dallas",
    region: RegionsEnum.DALLAS_TX,
    redliningRegion: RegionsEnum.DALLAS_TX,
    location: { lng: -96.80, lat: 32.78 },
    geoJson: "TXDallas1937.json",
    zoom: 12,
  },
  [RegionsEnum.ELPASO_TX]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Elpaso",
    region: RegionsEnum.ELPASO_TX,
    redliningRegion: RegionsEnum.ELPASO_TX,
    location: { lng: -95.36, lat: 29.75 },
    geoJson: "TXElPaso1936.json",
    zoom: 12,
  },
  [RegionsEnum.HOUSTON_TX]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Houston",
    region: RegionsEnum.HOUSTON_TX,
    redliningRegion: RegionsEnum.HOUSTON_TX,
    location: { lng: -95.36, lat: 29.75 },
    geoJson: "TXHouston001.json",
    zoom: 12,
  },
  [RegionsEnum.OGDEN_UT]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Ogden",
    region: RegionsEnum.OGDEN_UT,
    redliningRegion: RegionsEnum.OGDEN_UT,
    location: { lng: 0, lat: 0 },
    geoJson: "UTOgden19XX.json",
  },
  [RegionsEnum.SALTLAKECITY_UT]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Saltlakecity",
    region: RegionsEnum.SALTLAKECITY_UT,
    redliningRegion: RegionsEnum.SALTLAKECITY_UT,
    location: { lng: 0, lat: 0 },
    geoJson: "UTSaltLakeCity19XX.json",
    zoom: 12,
  },
  [RegionsEnum.LYNCHBURG_VA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Lynchburg",
    region: RegionsEnum.LYNCHBURG_VA,
    redliningRegion: RegionsEnum.LYNCHBURG_VA,
    location: { lng: 0, lat: 0 },
    geoJson: "VALynchburg1937.json",
  },
  [RegionsEnum.NORFOLK_VA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Norfolk",
    region: RegionsEnum.NORFOLK_VA,
    redliningRegion: RegionsEnum.NORFOLK_VA,
    location: { lng: 0, lat: 0 },
    geoJson: "VANorfolk1940.json",
  },
  [RegionsEnum.RICHMOND_VA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Richmond",
    region: RegionsEnum.RICHMOND_VA,
    redliningRegion: RegionsEnum.RICHMOND_VA,
    location: { lng: 0, lat: 0 },
    geoJson: "VARichmond1937.json",
  },
  [RegionsEnum.ROANOKE_VA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Roanoke",
    region: RegionsEnum.ROANOKE_VA,
    redliningRegion: RegionsEnum.ROANOKE_VA,
    location: { lng: 0, lat: 0 },
    geoJson: "VARoanoke1937.json",
  },
  [RegionsEnum.SEATTLE_WA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Seattle",
    region: RegionsEnum.SEATTLE_WA,
    redliningRegion: RegionsEnum.SEATTLE_WA,
    location: { lng: 0, lat: 0 },
    geoJson: "WASeattle1936.json",
  },
  [RegionsEnum.SPOKANE_WA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Spokane",
    region: RegionsEnum.SPOKANE_WA,
    redliningRegion: RegionsEnum.SPOKANE_WA,
    location: { lng: 0, lat: 0 },
    geoJson: "WASpokane1938.json",
  },
  [RegionsEnum.TACOMA_WA]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Tacoma",
    region: RegionsEnum.TACOMA_WA,
    redliningRegion: RegionsEnum.TACOMA_WA,
    location: { lng: 0, lat: 0 },
    geoJson: "WATacoma1937.json",
  },
  [RegionsEnum.KENOSHA_WI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Kenosha",
    region: RegionsEnum.KENOSHA_WI,
    redliningRegion: RegionsEnum.KENOSHA_WI,
    location: { lng: 0, lat: 0 },
    geoJson: "WIKenosha1937.json",
  },
  [RegionsEnum.MILWAUKEE_WI]: {
    enabled: true,
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Milwaukee",
    region: RegionsEnum.MILWAUKEE_WI,
    redliningRegion: RegionsEnum.MILWAUKEE_WI,
    location: { lng: 0, lat: 0 },
    geoJson: "WIMilwaukeeCo1937.json",
    zoom: 12,
  },
  [RegionsEnum.OSHKOSH_WI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Oshkosh",
    region: RegionsEnum.OSHKOSH_WI,
    redliningRegion: RegionsEnum.OSHKOSH_WI,
    location: { lng: 0, lat: 0 },
    geoJson: "WIOshkosh1938.json",
  },
  [RegionsEnum.RACINE_WI]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Racine",
    region: RegionsEnum.RACINE_WI,
    redliningRegion: RegionsEnum.RACINE_WI,
    location: { lng: 0, lat: 0 },
    geoJson: "WIRacine1937.json",
  },
  [RegionsEnum.CHARLESTON_WV]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Charleston",
    region: RegionsEnum.CHARLESTON_WV,
    redliningRegion: RegionsEnum.CHARLESTON_WV,
    location: { lng: 0, lat: 0 },
    geoJson: "WVCharleston1938.json",
  },
  [RegionsEnum.HUNTINGTON_WV]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Huntington",
    region: RegionsEnum.HUNTINGTON_WV,
    redliningRegion: RegionsEnum.HUNTINGTON_WV,
    location: { lng: 0, lat: 0 },
    geoJson: "WVHuntington19XX.json",
  },
  [RegionsEnum.WHEELING_WV]: {
    audioTour: false,
    firewall: true,
    titleRedlining: "",
    titleStories: "",
    label: "Wheeling",
    region: RegionsEnum.WHEELING_WV,
    redliningRegion: RegionsEnum.WHEELING_WV,
    location: { lng: 0, lat: 0 },
    geoJson: "WVWheeling1938.json",
  },

}
